(function faceMeasurement() {
    var _a;
    var selectors = {
        footer: "#shopify-section-footer",
        header: "#section-header",
        campaign: "#product-campaign",
        bottomBars: "#bottom-bars"
    };
    var url = window.location.pathname.split("/").pop();
    if (url == 'lite-measurements' || url == 'urban-measurements') {
        document.querySelector(selectors.footer).classList.add('hidden');
        document.querySelector(selectors.header).classList.add('hidden');
        document.querySelector(selectors.bottomBars).classList.add('hidden');
        if (document.querySelector(selectors.campaign)) {
            document.querySelector(selectors.campaign).classList.add('hidden');
        }
    }
    else {
        document.querySelector(selectors.footer).classList.remove('hidden');
        document.querySelector(selectors.header).classList.remove('hidden');
        (_a = document.querySelector(selectors.bottomBars)) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
        if (document.querySelector(selectors.campaign)) {
            document.querySelector(selectors.campaign).classList.remove('hidden');
        }
    }
})();
export {};
